<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <mat-form-field
      dir="ltr"
      class="numerical"
      floatLabel="always"
      appearance="fill"
    >
      <mat-label>{{ t('inspection.fields.zCoefficient') }}</mat-label>
      <input
        type="number"
        min="0"
        matInput
        placeholder="0"
        [drawableField]="
          (fieldSection || '') +
          ':' +
          (inspection?.title || '') +
          ':zCoefficient'
        "
        [drawableFieldTitle]="t('inspection.fields.zCoefficient')"
        [drawableFieldReadonly]="readonly"
        [(ngModel)]="inspection.value"
        [readonly]="readonly || printPreview"
        (input)="onChange()"
      />
    </mat-form-field>
  </authority-labs-check-case>
</ng-container>
